import React from 'react';
const SvgPdfThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg
      id="pdf-thumbnail_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...props}
    >
      <style>
        {
          '.pdf-thumbnail_svg__st0{display:none}.pdf-thumbnail_svg__st2{fill:#fff}.pdf-thumbnail_svg__st5{fill:#5c7896;fill-opacity:.9}'
        }
      </style>
      <g id="pdf-thumbnail_svg__assets">
        <path d="M11 3v94h78V23H69V3H11z" fill="#5c7896" />
        <path className="pdf-thumbnail_svg__st2" d="M15 8h54v15h16v50H15V8z" />
        <path d="M69 3l20 20H69V3z" fill="#769cc2" />
        <path d="M69 23h20v20L69 23z" opacity={0.3} fill="#1b3f63" />
        <g>
          <path
            className="pdf-thumbnail_svg__st5"
            d="M52 30h22v3H52zM52 21h15v3H52zM25 21h22v21H25zM52 39h22v3H52zM25 48h49v3H25zM25 57h41v3H25z"
          />
        </g>
        <g>
          <path
            className="pdf-thumbnail_svg__st2"
            d="M34.1 93V78.3h3.4c2.9 0 5.3 1.1 5.3 4.1 0 3.3-2.5 4.4-5.5 4.4h-1.4V93h-1.8zm1.7-7.6h1.1c2.2 0 4-.5 4-3 0-2-1.6-2.7-3.8-2.7h-1.4v5.7zM45.3 93V78.3h3.8c4.7 0 7.6 2.4 7.6 7.1 0 5.2-3.5 7.5-8.4 7.5h-3zm1.7-1.4h1.2c4.1 0 6.6-1.8 6.6-6.1 0-3.7-2.1-5.7-5.8-5.7h-2v11.8zM59.6 93V78.3H67v1.4h-5.6v5.1h5.4v1.4h-5.4V93h-1.8z"
          />
        </g>
      </g>
    </svg>
  );
});
export default SvgPdfThumbnail;
SvgPdfThumbnail.iconName = 'pdf-thumbnail';
SvgPdfThumbnail.displayName = 'SvgPdfThumbnail';
